// const colorTypes = [""];
// const colors = [
//   "orange",
//   "yellow",
//   "indigo",
//   "purple",
//   "pink",
//   "gray",
//   "blue",
//   "red",
//   "teal",
//   "green",
//   "lime",
//   "cyan",
//   "amber",
//   "emerald",
//   "darkBlue",
//   "violet",
//   "fuchsia",
//   "rose",
// ];
// const strengths = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900];

// const generateClasses = (types, colors, strengths) => {
//   return types
//     .map((type) => {
//       const allColors = colors.reduce((colors, color) => {
//         return [
//           ...colors,
//           ...strengths.flatMap((strength) => [
//             }-${strength}`,
//             }-${strength}`,
//             `bg-${color}-${strength}`,
//             `text-${color}-${strength}`,
//             }-${strength}`,
//           ]),
//         ];
//       }, []);
//       return allColors.flatMap((t) => `${type}${t}`);
//     })
//     .flat()
//     .join(" ");
// };

export const PurgeExceptions = () => {
  return (
    <div className="fixed top-0 left-0 min-w-0 min-h-0 w-0 h-0 hidden bg-yellow-50 text-yellow-50 bg-yellow-100 text-yellow-100 bg-yellow-200 text-yellow-200 bg-yellow-300 text-yellow-300 bg-yellow-400 text-yellow-400 bg-yellow-500 text-yellow-500 bg-yellow-600 text-yellow-600 bg-yellow-700 text-yellow-700 bg-yellow-800 text-yellow-800 bg-yellow-900 text-yellow-900 bg-gray-50 text-gray-50 bg-gray-100 text-gray-100 bg-gray-200 text-gray-200 bg-gray-300 text-gray-300 bg-gray-400 text-gray-400 bg-gray-500 text-gray-500 bg-gray-600 text-gray-600 bg-gray-700 text-gray-700 bg-gray-800 text-gray-800 bg-gray-900 text-gray-900 bg-blue-50 text-blue-50 bg-blue-100 text-blue-100 bg-blue-200 text-blue-200 bg-blue-300 text-blue-300 bg-blue-400 text-blue-400 bg-blue-500 text-blue-500 bg-blue-600 text-blue-600 bg-blue-700 text-blue-700 bg-blue-800 text-blue-800 bg-blue-900 text-blue-900 bg-red-50 text-red-50 bg-red-100 text-red-100 bg-red-200 text-red-200 bg-red-300 text-red-300 bg-red-400 text-red-400 bg-red-500 text-red-500 bg-red-600 text-red-600 bg-red-700 text-red-700 bg-red-800 text-red-800 bg-red-900 text-red-900 bg-green-50 text-green-50 bg-green-100 text-green-100 bg-green-200 text-green-200 bg-green-300 text-green-300 bg-green-400 text-green-400 bg-green-500 text-green-500 bg-green-600 text-green-600 bg-green-700 text-green-700 bg-green-800 text-green-800 bg-green-900 text-green-900 bg-primary-50 text-primary-50 bg-primary-100 text-primary-100 bg-primary-200 text-primary-200 bg-primary-300 text-primary-300 bg-primary-400 text-primary-400 bg-primary-500 text-primary-500 bg-primary-600 text-primary-600 bg-primary-700 text-primary-700 bg-primary-800 text-primary-800 bg-primary-900 text-primary-900 bg-warning-50 text-warning-50 bg-warning-100 text-warning-100 bg-warning-200 text-warning-200 bg-warning-300 text-warning-300 bg-warning-400 text-warning-400 bg-warning-500 text-warning-500 bg-warning-600 text-warning-600 bg-warning-700 text-warning-700 bg-warning-800 text-warning-800 bg-warning-900 text-warning-900 bg-success-50 text-success-50 bg-success-100 text-success-100 bg-success-200 text-success-200 bg-success-300 text-success-300 bg-success-400 text-success-400 bg-success-500 text-success-500 bg-success-600 text-success-600 bg-success-700 text-success-700 bg-success-800 text-success-800 bg-success-900 text-success-900 bg-info-50 text-info-50 bg-info-100 text-info-100 bg-info-200 text-info-200 bg-info-300 text-info-300 bg-info-400 text-info-400 bg-info-500 text-info-500 bg-info-600 text-info-600 bg-info-700 text-info-700 bg-info-800 text-info-800 bg-info-900 text-info-900"></div>
  );
};
